@if ($isMobileView()) {
  <boels-account-mobile
    [boelsUser]="boelsUser()"
    [isActive]="$isNavigationOverlayOpen()"
    [activeCulture]="activeCulture()"
    (closeModuleEvent)="setAccountNavigationOverlay(false)"
    (login)="login.emit()"
    (logout)="logout.emit()"
    (openLanguageSelector)="openLanguageSelector.emit()"
  ></boels-account-mobile>
  <button
    #accountButton
    class="boels-account__account-indicator-button"
    [class.-mobile-login]="
      $isMobileView() && boelsUser().type !== userType.B2C_AUTHENTICATED
    "
    tabindex="0"
    (click)="toggleAccountNavigationOverlay($event)"
    (keydown)="handleAccountButtonKeyDown($event)"
    aria-haspopup="true"
    [attr.aria-expanded]="$isNavigationOverlayOpen()"
  >
    <boels-account-indicator
      [boelsUser]="boelsUser()"
    ></boels-account-indicator>
  </button>
} @else {
  @switch (boelsUser().type) {
    @case (userType.B2C_AUTHENTICATED) {
      <ng-container
        [ngTemplateOutlet]="accountTemplate"
        [ngTemplateOutletContext]="{ $implicit: boelsUser().debtor }"
      ></ng-container>
    }
    @default {
      <ng-container [ngTemplateOutlet]="loginTemplate"></ng-container>
    }
  }
}

<ng-template
  #accountTemplate
  [boelsTemplateContext]="boelsUser().debtor"
  let-debtor
>
  @defer (when debtor) {
    <div class="boels-account">
      <button
        #accountButton
        class="boels-account__account-indicator-button"
        [class.-mobile-login]="
          $isMobileView() && boelsUser().type !== userType.B2C_AUTHENTICATED
        "
        tabindex="0"
        (click)="toggleAccountNavigationOverlay($event)"
        (keydown)="handleAccountButtonKeyDown($event)"
        aria-haspopup="true"
        [attr.aria-expanded]="$isNavigationOverlayOpen()"
      >
        <boels-account-indicator
          [boelsUser]="boelsUser()"
        ></boels-account-indicator>
      </button>

      <!-- Desktop navigation overlay -->
      @if ($isNavigationOverlayOpen()) {
        <div
          #accountMenu
          class="boels-account-navigation"
          role="menu"
          (click)="$event.stopPropagation()"
        >
          <div class="boels-account-navigation__container">
            <div class="boels-account-navigation__content">
              @for (item of menuItemsList; track $index) {
                @if (
                  (item.shouldHaveDebtorData && boelsUser().debtor?.name) ||
                  !item.shouldHaveDebtorData
                ) {
                  <div
                    #menuItem
                    class="boels-account-navigation__item"
                    role="menuitem"
                    tabindex="0"
                    (click)="menuItemClicked(item, $event)"
                    (keydown)="handleMenuItemKeyDown(item, $event)"
                    [attr.aria-label]="
                      item.title
                        ? (item.title | transloco)
                        : (item.subtitle | transloco)
                    "
                  >
                    <div class="boels-account-navigation__item-content">
                      @if (item.icon) {
                        <fa-icon
                          class="boels-account-navigation__item-icon"
                          [ngClass]="item.iconClass"
                          [icon]="item.icon"
                        ></fa-icon>
                      } @else if (item.imgSrc) {
                        <img
                          class="boels-account-navigation__item-icon {{
                            item.iconClass
                          }}"
                          [src]="item.imgSrc"
                          [alt]="'header.auth.product' | transloco"
                          loading="lazy"
                        />
                      }
                      <div class="boels-account-navigation__item-text">
                        @if (item.title) {
                          <span
                            class="boels-account-navigation__item-title"
                            boelsQa="menu-item-title"
                          >
                            {{ item.title | transloco }}
                          </span>
                        }
                        @if (item.subtitle || item.subtitleBinding) {
                          <span
                            class="boels-account-navigation__item-subtitle"
                            boelsQa="menu-item-subtitle"
                            >{{
                              item.subtitleBinding
                                ? getSubtitle(item.subtitleBinding)
                                : (item.subtitle | transloco)
                            }}</span
                          >
                        }
                        @if (item.showLanguageSelector) {
                          <boels-toggle-language-selector
                            class="boels-account-navigation__item-language-selector"
                            boelsQa="menu-item-subtitle"
                            #languageToggle
                            [textOnly]="true"
                            [cssClassForText]="
                              'boels-account-navigation__item-subtitle'
                            "
                          ></boels-toggle-language-selector>
                        }
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      }
    </div>
  } @loading {
    <div class="loading-indicator"></div>
  }
</ng-template>

<ng-template #loginTemplate>
  <boels-login-indicator
    (loginClicked)="login.emit()"
    (keydown.enter)="login.emit()"
    tabindex="0"
  ></boels-login-indicator>
</ng-template>
